import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="relative z-10 mt-auto border-t border-[#ff0090]/20 bg-black/40 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} UCL Legacy UG. Alle Rechte vorbehalten.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              to="/impressum" 
              className="text-white/40 hover:text-[#ff0090] text-sm transition-colors"
              data-testid="footer-impressum-link"
            >
              Impressum
            </Link>
            <Link 
              to="/datenschutz" 
              className="text-white/40 hover:text-[#ff0090] text-sm transition-colors"
              data-testid="footer-datenschutz-link"
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
